export default __webpack_public_path__ + "static/media/logoCliniter.97c11e3c.png";